import React from "react";
import { Toolbar, AppBar, Button, Box, IconButton } from "@mui/material";
import { sections } from "./sections";
import { APP_COLORS } from "../../../utils/constants";
import "./nav.css";

import MenuIcon from "@mui/icons-material/Menu";
import MobileDrawer from "./MobileDrawer";
import Logo from "./Logo";

export default function Navbar({ activeSection, handleNavClick }) {
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  return (
    <>
      <AppBar
        position="fixed"
        component="nav"
        sx={{
          backgroundColor: APP_COLORS.BACKGROUND,
          width: "100%",
          color: APP_COLORS.FONT,
          boxShadow: "none",
          pr: "5rem",
          pl: { xs: "0rem", md: "6.8rem" },
          py: { xs: ".8rem", md: "1.4rem" },
          // borderBottom: {
          //   xs: "1px solid  red",
          //   sm: "1px solid  yellow",
          //   md: "1px solid green",
          //   lg: "1px solid blue",
          // },
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, ml: 1, display: { md: "none" } }}
          >
            <MenuIcon />
          </IconButton>

          <Box
            sx={{
              flexGrow: 1,
              cursor: "pointer",
              display: mobileOpen && "none",
            }}
          >
            <Logo handleNavClick={handleNavClick} />
          </Box>

          <Box sx={{ display: { xs: "none", md: "flex" } }}>
            {sections.map((page) => {
              return (
                <Button
                  className={
                    "nav-link " +
                    (activeSection === page.id ? "nav-link-active" : "")
                  }
                  onClick={() => handleNavClick(page.id)}
                  // component={NavLink}
                  // to={page.link}
                  key={page.label}
                  color="inherit"
                  sx={{
                    backgroundColor: APP_COLORS.BACKGROUND,
                    marginLeft: 3,
                    fontSize: "1rem",
                    py: 2,
                    "&:hover": {
                      backgroundColor: APP_COLORS.BACKGROUND,
                    },
                    transition: "all 0.3s ease",
                    display: { xs: "none", md: "block" },
                  }}
                  // sx={{
                  // }}
                >
                  {page.label}
                </Button>
              );
            })}
          </Box>
        </Toolbar>
      </AppBar>

      <MobileDrawer
        mobileOpen={mobileOpen}
        handleDrawerToggle={handleDrawerToggle}
        activeSection={activeSection}
        handleNavClick={handleNavClick}
      />
    </>
  );
}
